export const ROUTES = Object.freeze({
  HOME: "/",
  LOGIN: "/login",
  REGISTER: "/register",
  CONFIRM: "/confirm",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  PROFILE: "/profile",
  PLAYERS: "/players",
  GAMES: "/games",
  FACILITY_RULES: "/facility-rules",
  DELETE_ACCOUNT: "/delete-account",
});

export const buildGamePath = (gameId) => {
  const normalizedId = String(gameId || "").trim();
  if (!normalizedId) return ROUTES.HOME;
  return `${ROUTES.GAMES}/${encodeURIComponent(normalizedId)}`;
};

export const buildProfilePath = (tab, extraParams = {}) => {
  const normalizedTab = String(tab || "").trim();
  const params = new URLSearchParams();

  if (normalizedTab) params.set("tab", normalizedTab);

  if (extraParams && typeof extraParams === "object") {
    Object.entries(extraParams).forEach(([key, value]) => {
      if (value === undefined || value === null || value === "") return;
      params.set(key, String(value));
    });
  }

  const query = params.toString();
  return query ? `${ROUTES.PROFILE}?${query}` : ROUTES.PROFILE;
};

export const isOwnPlayerPath = (playerId, currentUserId) => {
  const normalizedPlayerId = String(playerId || "").trim();
  const normalizedCurrentUserId = String(currentUserId || "").trim();

  return Boolean(normalizedPlayerId && normalizedCurrentUserId && normalizedPlayerId === normalizedCurrentUserId);
};

export const buildPlayerPath = (playerId, extraParams = {}) => {
  const normalizedId = String(playerId || "").trim();
  if (!normalizedId) return ROUTES.HOME;

  const params = new URLSearchParams();

  if (extraParams && typeof extraParams === "object") {
    Object.entries(extraParams).forEach(([key, value]) => {
      if (value === undefined || value === null || value === "") return;
      params.set(key, String(value));
    });
  }

  const query = params.toString();
  const basePath = `${ROUTES.PLAYERS}/${encodeURIComponent(normalizedId)}`;
  return query ? `${basePath}?${query}` : basePath;
};
